export { default as home } from "./home";
export { default as aboutMe } from "./aboutMe";
export { default as viewNotFound } from "./viewNotFound";
export { default as rockPaperScissors } from "./rockPaperScissors.js";
export { default as results } from "./results.js";
export { default as move } from "./move.js";
export { default as join } from "./join.js";
